if (!customElements.get('notify-me-button')) {
  customElements.define('notify-me-button', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.trigger = this.querySelector('[data-omnisend-form-id]');
      if (!this.trigger) return;
      this.variantId = this.dataset.variantId;
      this.trigger.addEventListener('click', this.handleClick.bind(this));

      const picker = this.closest('.product-info')?.querySelector('variant-picker');
      if (picker) {
        picker.addEventListener('on:variant:change', (evt) => {
          const { variant } = evt.detail;
          this.hidden = !variant || variant.available;
          if (variant) this.variantId = String(variant.id);
        });
      }
      document.addEventListener('omnisend-viewed-product', () => {
        if (!this.hidden) this.setOmnisendVariant();
      });
      if (window.location.hash === '#notify-me' && !this.hidden) this.openForm();
    }

    handleClick(evt) {
      evt.preventDefault();
      this.openForm();
    }

    setOmnisendVariant() {
      const omnisend = window._omnisend;
      const info = omnisend?.getProductInfo?.();
      if (!info || typeof omnisend.setProductInfo !== 'function' || !this.variantId) return;
      if (info.variantID === this.variantId && info.status === 'outOfStock') return;

      omnisend.setProductInfo({
        properties: {
          product: {
            id: info.productID,
            variantId: this.variantId,
            status: 'outOfStock',
            currency: info.currency,
            description: info.description,
            imageUrl: info.imageUrl,
            price: info.price,
            oldPrice: info.oldPrice,
            title: info.title,
            url: info.url,
            productTitle: info.productTitle,
            productImageUrl: info.productImageUrl,
            productUrl: info.productUrl
          }
        }
      });
    }

    openForm() {
      this.setOmnisendVariant();
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', this.trigger.dataset.omnisendFormId]);
    }
  });
}
